module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "liveEventContent"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "liveEvent"
  }, [_c('h3', [_vm._v("Hey, Jane. Great to see you. Welcome to TONE Live!")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": _vm.jwEventRef,
      "frameborder": "0",
      "scrolling": "auto",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('iframe', {
    attrs: {
      "width": "100%",
      "height": "220",
      "frameborder": "0",
      "scrolling": "no",
      "marginheight": "0",
      "marginwidth": "0",
      "allowtransparency": "true",
      "src": _vm.chatRollURL
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "attendees"
  }, [_c('div', {
    staticClass: "attendeesContent"
  }, [_c('h2', [_vm._v("attendees")]), _vm._v(" "), _c('div', {
    staticClass: "liveEventImage"
  }, [(_vm.eventUsersArray) ? _c('div', {
    staticClass: "slider responsive-slick-slider-live"
  }, _vm._l((_vm.eventUsersArray), function(userList) {
    return _c('div', {
      staticClass: "sliderBox"
    }, [(userList[0]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[0].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[0].picture,
        "alt": "USER-SHOE",
        "title": userList[0].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[0].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[0].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-cognito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[1]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[1].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[1].picture,
        "alt": "USER-SHOE",
        "title": userList[1].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[1].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[1].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-cognito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[2]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[2].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[2].picture,
        "alt": "USER-SHOE",
        "title": userList[2].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[2].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[2].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-cognito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[3]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[3].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[3].picture,
        "alt": "USER-SHOE",
        "title": userList[3].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[3].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[3].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-congnito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[4]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[4].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[4].picture,
        "alt": "USER-SHOE",
        "title": userList[4].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[4].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[4].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-cognito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[5]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[5].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[5].picture,
        "alt": "USER-SHOE",
        "title": userList[5].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[5].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[5].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-cognito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[6]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[6].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[6].picture,
        "alt": "USER-SHOE",
        "title": userList[6].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[6].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[6].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-cognito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[7]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[7].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[7].picture,
        "alt": "USER-SHOE",
        "title": userList[7].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[7].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[7].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-congnito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[8]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[8].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[8].picture,
        "alt": "USER-SHOE",
        "title": userList[8].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[8].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[8].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-congnito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[9]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[9].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[9].picture,
        "alt": "USER-SHOE",
        "title": userList[9].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[9].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[9].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-cognito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[10]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[10].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[10].picture,
        "alt": "USER-SHOE",
        "title": userList[10].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[10].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[10].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-congnito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[11]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[11].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[11].picture,
        "alt": "USER-SHOE",
        "title": userList[11].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[11].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[11].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-cognito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[12]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[12].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[12].picture,
        "alt": "USER-SHOE",
        "title": userList[12].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[12].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[12].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-cognito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[13]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[13].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[13].picture,
        "alt": "USER-SHOE",
        "title": userList[13].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[13].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[13].picture,
        "alt": "USER-SHOE",
        "title": "Shoe-congnito"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e(), _vm._v(" "), (userList[14]) ? _c('div', {
      staticClass: "liveImage"
    }, [(userList[14].isAnonymous === '0') ? _c('div', [_c('img', {
      attrs: {
        "src": userList[14].picture,
        "alt": "USER-SHOE",
        "title": userList[14].firstName
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(userList[14].firstName))])]) : _c('div', [_c('img', {
      attrs: {
        "src": userList[14].picture,
        "alt": "USER-SHOE",
        "title": _vm.Shoe - _vm.cognito
      }
    }), _vm._v(" "), _c('span', [_vm._v("Shoe-cognito")])])]) : _vm._e()])
  }), 0) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "aboutExpert"
  }, [_c('h2', [_vm._v("about the expert")]), _vm._v(" "), _c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.getExpert[0].small_image,
      "alt": _vm.getExpert[0].name,
      "title": _vm.getExpert[0].name
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.getExpert[0].name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getExpert[0].experties))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.getSelectedEvent[0].longDescription) + "\n                    ")])])])])])
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42f3802e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/LiveEventDemo.vue